<script setup>
import { ref } from 'vue';
import ReportHeader from './components/ReportHeader.vue';
import AgentsSummaryReports from './components/AgentsSummaryReports.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const summaryReportsRef = ref(null);

const onDownloadClick = () => {
  summaryReportsRef.value.downloadReports();
};
</script>

<template>
  <ReportHeader
    :header-title="$t('AGENT_REPORTS.HEADER')"
    :header-description="$t('AGENT_REPORTS.DESCRIPTION')"
  >
    <V4Button
      :label="$t('AGENT_REPORTS.DOWNLOAD_AGENT_REPORTS')"
      icon="i-ph-download-simple"
      size="sm"
      @click="onDownloadClick"
    />
  </ReportHeader>

  <AgentsSummaryReports
    ref="summaryReportsRef"
    action-key="summaryReports/fetchAgentSummaryReports"
    getter-key="agents/getAgents"
    fetch-items-key="agents/get"
    summary-key="summaryReports/getAgentSummaryReports"
    type="agent"
  />
</template>
